import { Plus, Wallet } from "lucide-react";
import { Button } from "@/modern/components/ui/button-shadcn";

export const BudgetEmptyState = ({
  onAddBudget,
  addBudgetDisabled,
}: {
  onAddBudget: () => void;
  addBudgetDisabled?: boolean;
}) => {
  return (
    <div className="min-h-[12rem] h-full flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-muted-foreground/30 bg-muted/40 p-4 text-center shadow-sm">
      <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
        <Wallet className="size-5" />
      </span>
      <div className="space-y-1">
        <h3 className="text-sm font-semibold text-foreground">No Budget Linked</h3>
        <p className="text-xs text-muted-foreground">
          Add a budget to track costs and profitability for this task.
        </p>
      </div>
      <Button size="sm" disabled={addBudgetDisabled} onClick={onAddBudget}>
        <Plus className="size-4 mr-1" />
        Add Budget
      </Button>
    </div>
  );
};
